import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  styleUrls: ['./pdfviewer.component.scss']
})
export class PdfviewerComponent implements OnInit {
  src;
  src1;
  pdfSrc;
fileType = "";
imageSrc = ""
  zoomLevel: number;
  constructor(private dialogRef: MatDialogRef<PdfviewerComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private spinner: NgxSpinnerService
  ) {
    this.src = data
  }
  isImage = false;
  ispdf= false;
  noDataaa= false;
  showBtn = false;
  ngOnInit(): void {
    this.src = this.data
    if(this.src == undefined || this.src == ''){
      this.noDataaa = true;
      this.ispdf = false;
     this.isImage = false;
     this.showBtn=false;
    }
    if (this.src.startsWith('data:image')) {
      this.isImage = true;
      this.ispdf = false;
      this.noDataaa = false;
      this.showBtn = true
    }
    else { 
      this.isImage = false;
      this.noDataaa = false;
      this.ispdf = true;
      this.showBtn = true
      // this.src = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
      // this.src1 = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
    }
  
  }

  dowload()
  {
    const link=document.createElement("a");
     link.href=this.src;
     link.download='Download';
     link.click()
  }


  zoomIn() {
    this.zoomLevel += 0.1; // Increase the zoom level
  }
  
  zoomOut() {
    this.zoomLevel -= 0.1; // Decrease the zoom level
  }
}